import React from 'react'
import Color from '../../../../npo-start-player-web/src/theme/color'
import FormNumber from '../number/FormNumber'
import './form-color.scss'

/**
 * The props
 */
export interface FormColorProps {
    /**
     * The value of the color
     */
    value: Color

    /**
     * The callback for when the color changes.
     */
    onChange: (value: Color) => void

    /**
     * The callback for when one of the inputs blurs out.
     */
    onBlur?: () => void
}

/**
 * Modify a color in a form.
 * 
 * @author Stan Hurks
 */
export default class FormColor extends React.Component<FormColorProps> {

    public render = () => {
        return (
            <div className="form-color">
                <div className="form-color-left">
                    <div className="form-color-left-color" style={{
                        background: `rgba(
                            ${this.props.value.r},
                            ${this.props.value.g},
                            ${this.props.value.b},
                            1
                        )`
                    }}>
                    </div>
                </div>
                <div className="form-color-right">
                    <div className="form-color-right-table">
                        <div className="form-color-right-table-column">
                            <div className="form-color-right-table-column-container">
                                <div className="form-color-right-table-column-container-label">
                                    <div className="form-color-right-table-column-container-label-value">
                                        R
                                    </div>
                                </div>
                                <div className="form-color-right-table-column-container-number">
                                    <FormNumber
                                        value={this.props.value.r}
                                        onChange={(r) => {
                                            this.props.onChange({
                                                ...this.props.value,
                                                r
                                            })
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                if (this.props.onBlur) {
                                                    this.props.onBlur()
                                                }
                                            })
                                        }}
                                        min={0}
                                        max={255}
                                        />
                                </div>
                            </div>
                        </div>
                        <div className="form-color-right-table-column">
                            <div className="form-color-right-table-column-container">
                                <div className="form-color-right-table-column-container-label">
                                    <div className="form-color-right-table-column-container-label-value">
                                        G
                                    </div>
                                </div>
                                <div className="form-color-right-table-column-container-number">
                                    <FormNumber
                                        value={this.props.value.g}
                                        onChange={(g) => {
                                            this.props.onChange({
                                                ...this.props.value,
                                                g
                                            })
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                if (this.props.onBlur) {
                                                    this.props.onBlur()
                                                }
                                            })
                                        }}
                                        min={0}
                                        max={255}
                                        />
                                </div>
                            </div>
                        </div>
                        <div className="form-color-right-table-column">
                            <div className="form-color-right-table-column-container">
                                <div className="form-color-right-table-column-container-label">
                                    <div className="form-color-right-table-column-container-label-value">
                                        B
                                    </div>
                                </div>
                                <div className="form-color-right-table-column-container-number">
                                    <FormNumber
                                        value={this.props.value.b}
                                        onChange={(b) => {
                                            this.props.onChange({
                                                ...this.props.value,
                                                b
                                            })
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                if (this.props.onBlur) {
                                                    this.props.onBlur()
                                                }
                                            })
                                        }}
                                        min={0} 
                                        max={255}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}